@if (label) {
  <label class="form-label" [innerHTML]="label"> </label>
  @if (requiredLabel) {
    <span class="text-danger"> *</span>
  }
}
<div class="position-relative">
  <input
    #inputElement
    [id]="id"
    [type]="type"
    class="form-control {{ customClass }} {{ ngControl?.invalid && ngControl?.touched ? 'is-invalid' : '' }}"
    [placeholder]="placeholder"
    [(ngModel)]="value"
    (input)="onInputChange($event)"
    (keydown)="onKeyDown($event)"
    (paste)="onPaste($event)"
    (focus)="onNumberFocus()"
    (blur)="onNumberBlur()"
    [disabled]="ngControl?.disabled || disabled"
    [min]="min"
    [max]="max"
    [spellcheck]="spellcheck"
  />

  @if (passwordType === 'password') {
    <span
      class="top-50 translate-middle position-absolute end-0 me-2 fw-semibold cursor-pointer fs-12 text-gray-300"
      (click)="togglePasswordVisibility()"
    >
      {{ isPasswordVisible ? 'Hide' : 'Show' }}
    </span>
  }
</div>

@if (ngControl?.touched && ngControl?.invalid) {
  <div class="text-danger fs-14">
    <span>{{ errormessage }}</span>
  </div>
}
